import UserApi from 'app/api/UserApi';
import { useApiErrorToast } from 'app/api/app-api/apiHooksHelpers';
import { useEffect, useState } from 'react';
import { Box, Button, Input, Modal, ModalActions, ModalContent, ModalHeader, ModalLayout, Text, useToasts, useTombac } from 'tombac';
import { CopyIcon, WarningIcon } from 'tombac-icons';
import { useUserDetails } from "../UserDetailsProvider";
import { useActivationLinkQuery } from "../api/userManagementApiHooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ActivationLinkModal = ({
  isOpen,
  onRequestClose
}) => {
  const addApiErrorToast = useApiErrorToast();
  const {
    addToast
  } = useToasts();
  const tombac = useTombac();
  const userDetails = useUserDetails();
  const [isLinkDisplayed, setIsLinkDisplayed] = useState(false);
  const {
    data,
    error,
    isLoading
  } = useActivationLinkQuery({
    username: userDetails.email
  }, {
    enabled: isLinkDisplayed
  });
  const handleShowActivationLink = () => {
    setIsLinkDisplayed(true);
  };
  const [isResending, setIsResending] = useState(false);
  const handleResendActivationEmail = async event => {
    setIsResending(true);
    try {
      await UserApi.resendEmail(userDetails.email);
      addToast('Activation email sent', 'success');
      onRequestClose(event);
    } catch (e) {
      addApiErrorToast(error, 'An error occurred while resending the activation email');
    } finally {
      setIsResending(false);
    }
  };
  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(data.activationLink);
      addToast('The activation link has been copied to the clipboard', 'success');
    } catch (e) {
      addToast('An error occurred while copying the activation link to the clipboard', 'danger');
    }
  };
  const handleLinkInputFocus = event => {
    event.target.select();
  };
  useEffect(() => {
    if (isOpen) {
      setIsLinkDisplayed(false);
    }
  }, [isOpen]);
  return /*#__PURE__*/_jsx(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "ActivationLinkModal",
    "data-sentry-source-file": "ActivationLinkModal.tsx",
    children: /*#__PURE__*/_jsxs(ModalLayout, {
      size: "l",
      "data-sentry-element": "ModalLayout",
      "data-sentry-source-file": "ActivationLinkModal.tsx",
      "data-sentry-element": "ModalLayout",
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        "data-sentry-element": "ModalHeader",
        "data-sentry-source-file": "ActivationLinkModal.tsx",
        "data-sentry-element": "ModalHeader",
        children: "Activation link"
      }), /*#__PURE__*/_jsxs(ModalContent, {
        "data-sentry-element": "ModalContent",
        "data-sentry-source-file": "ActivationLinkModal.tsx",
        "data-sentry-element": "ModalContent",
        children: [/*#__PURE__*/_jsxs(Box, {
          $alignItems: "center",
          $display: "flex",
          "data-sentry-element": "Box",
          "data-sentry-source-file": "ActivationLinkModal.tsx",
          "data-sentry-element": "Box",
          children: [/*#__PURE__*/_jsx(Box, {
            $flex: "none",
            $mr: "2sp",
            "data-sentry-element": "Box",
            "data-sentry-source-file": "ActivationLinkModal.tsx",
            "data-sentry-element": "Box",
            children: /*#__PURE__*/_jsx(WarningIcon, {
              color: tombac.color('alert'),
              "data-sentry-element": "WarningIcon",
              "data-sentry-source-file": "ActivationLinkModal.tsx",
              "data-sentry-element": "WarningIcon"
            })
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(Text, {
              $mb: "1sp",
              "data-sentry-element": "Text",
              "data-sentry-source-file": "ActivationLinkModal.tsx",
              "data-sentry-element": "Text",
              children: "Please note that manually providing the activation link will leave the user's email address unverified. This may result in not receiving important email notifications from our systems and will prevent the user from using the \"Forgot password\" function."
            }), /*#__PURE__*/_jsx(Text, {
              "data-sentry-element": "Text",
              "data-sentry-source-file": "ActivationLinkModal.tsx",
              "data-sentry-element": "Text",
              children: "We recommend trying to resend the activation email first."
            })]
          })]
        }), /*#__PURE__*/_jsx(Box, {
          $mt: "3sp",
          "data-sentry-element": "Box",
          "data-sentry-source-file": "ActivationLinkModal.tsx",
          "data-sentry-element": "Box",
          children: isLinkDisplayed && !isLoading ? error ? /*#__PURE__*/_jsx(Text, {
            $minHeight: "5sp",
            variant: "danger",
            children: "An error occurred while generating the activation link. Please try again later."
          }) : /*#__PURE__*/_jsx(Box, {
            $alignItems: "center",
            $display: "flex",
            children: /*#__PURE__*/_jsx(Input, {
              $flex: "auto",
              append: /*#__PURE__*/_jsx(Button, {
                onClick: handleCopyLink,
                shape: "circle",
                size: "s",
                variant: "flat",
                children: /*#__PURE__*/_jsx(CopyIcon, {})
              }),
              onFocus: handleLinkInputFocus,
              readOnly: true,
              value: data.activationLink
            })
          }) : /*#__PURE__*/_jsxs(Box, {
            $alignItems: "center",
            $display: "flex",
            $minHeight: "5sp",
            children: [/*#__PURE__*/_jsx(Button, {
              busy: isLoading,
              onClick: handleShowActivationLink,
              size: "s",
              variant: "flat",
              children: "Show activation link"
            }), /*#__PURE__*/_jsx(Button, {
              $ml: "2sp",
              busy: isResending,
              onClick: handleResendActivationEmail,
              size: "s",
              variant: "primary",
              children: "Resend activation email"
            })]
          })
        })]
      }), /*#__PURE__*/_jsx(ModalActions, {
        "data-sentry-element": "ModalActions",
        "data-sentry-source-file": "ActivationLinkModal.tsx",
        "data-sentry-element": "ModalActions",
        children: /*#__PURE__*/_jsx(Button, {
          onClick: onRequestClose,
          variant: "flat",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "ActivationLinkModal.tsx",
          "data-sentry-element": "Button",
          children: "Close"
        })
      })]
    })
  });
};